import { render, staticRenderFns } from "./SidebarSso.vue?vue&type=template&id=cbb07be0&scoped=true"
import script from "./SidebarSso.vue?vue&type=script&lang=js"
export * from "./SidebarSso.vue?vue&type=script&lang=js"
import style0 from "./SidebarSso.vue?vue&type=style&index=0&id=cbb07be0&prod&scoped=true&lang=css"
import style1 from "./SidebarSso.vue?vue&type=style&index=1&id=cbb07be0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb07be0",
  null
  
)

export default component.exports